import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import App from './app/app';
import * as Sentry from '@sentry/react';
import * as ReactDOM from 'react-dom/client';

import { AuthProvider } from '@ducks/ui';

Sentry.init({
  dsn: 'https://5a091446b1bc65d9b3b70930d8506a35@o4504120422039552.ingest.us.sentry.io/4509621925904384',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
